export default __webpack_public_path__ + "static/universal-menu-1-afc18c8a773bcee89d20c4ffaa9c3ba2.jpg";